var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[(_vm.titulo)?_c('v-card-title',[_vm._v(_vm._s(_vm.titulo))]):_vm._e(),_c('v-card-text',[_vm._t("default")],2),(_vm.barraBotoes)?_c('v-card-actions',[_c('v-spacer'),_vm._t("botoes")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }